import React from 'react';

const MainDashboard = ({ user, ...others }) => {
  return (
    <React.Fragment>
      <h1>Slack Status</h1>
      <div>Please select user from left section.</div>
    </React.Fragment>
  );
};

export default MainDashboard;



// WEBPACK FOOTER //
// ./src/modules/App/Dashboard.js